import { logger } from '@sentry/react';
import { useEffect } from 'react';
import { useModal } from '../../context/Modal/useModal';
import { getBrowserInfo } from '../../utils/browserInfo';
import { isLocalStorageAvailable } from '../../utils/isLocalStorageAvailable';
import { LocalStorageWarningModal } from './LocalStorageWarningModal';

export function LocalStorageCheck({ canvasId }: { canvasId: string }) {
  const { onOpen } = useModal();

  useEffect(() => {
    if (!isLocalStorageAvailable()) {
      logger.warn('localStorage unavailable on canvas open', {
        canvasId,
        browser: getBrowserInfo(),
      });
      onOpen(<LocalStorageWarningModal />);
    }
  }, [canvasId, onOpen]);

  return null;
}
